import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', href: '/' },
    { label: '分类浏览', href: '/category' },
    { label: '最新资讯', href: '/category?tab=articles' },
    { label: '关于我们', href: '/about' },
  ],
  热门分类: [
    { label: '电视剧', href: '/category?tab=电视剧' },
    { label: '电影', href: '/category?tab=电影' },
    { label: '综艺', href: '/category?tab=综艺' },
    { label: '动漫', href: '/category?tab=动漫' },
  ],
  推荐平台: [
    { label: '香蕉视频', href: '#' },
    { label: '91视频', href: '#' },
    { label: '蜜桃视频', href: '#' },
    { label: '樱花视频', href: '#' },
  ],
  帮助支持: [
    { label: '常见问题', href: '/#faq' },
    { label: '观看指南', href: '/article/viewing-device-guide' },
    { label: '反馈建议', href: '/about#contact' },
    { label: '隐私政策', href: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-white mb-4 whitespace-nowrap">{title}</h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('/') ? (
                      <Link
                        to={link.href}
                        className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                        rel="nofollow"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 flex items-center justify-center rounded-md bg-primary-500">
                <i className="ri-play-mini-fill text-white text-sm"></i>
              </div>
              <span className="font-heading text-white font-bold text-lg">茄子视频</span>
            </div>
            <p className="text-xs text-background-500 text-center">
              &copy; 2026 茄子视频 版权所有 | 高清免费在线观看平台
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}